export enum Roles {
  MasterAdmin = 'NC.MasterAdmin',
  Allocator = 'NC.Allocator',
  AgencyAdmin = 'NC.AgencyAdmin',
  AgencyUser = 'NC.AgencyUser',
  CampaignAdmin = 'NC.CampaignAdmin',
}
